import { NewsLetterHeader } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  NewsletterHeader: {
    SVG: NewsLetterHeader.AveveAgrarisch,
    className: 'newsletter-svg',
  },
  breadcrumb: {
    display: true,
  },
  button: {
    ctaBanner: {
      image: 'primary-with-background',
      text: 'primary-with-background',
    },
    ctaGroup: 'primary',
    infoBlock: 'primary-with-background',
    infoBlockColumns: 'primary-with-background',
    infoSection: 'primary-with-background',
    shortBanner: 'primary-with-background',
  },
  footer: {
    version: 'V2',
  },
});

export default config;
